import { HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { TenantContextService } from '../services/tenant-context.service';

/**
 * Tenant Interceptor - Automatically adds TenantId header to all API requests
 * Similar to Trade Tracking System pattern
 * Tenant ID is retrieved from JWT token via TenantContextService
 */
export const tenantInterceptor: HttpInterceptorFn = (req, next) => {
  const tenantContext = inject(TenantContextService);
  const tenantId = tenantContext.getCurrentTenantId();
  const businessUnitId = tenantContext.getCurrentBusinessUnitId();

  // Skip tenant header for public endpoints (login, register, etc.)
  const publicEndpoints = ['/auth/login', '/auth/register', '/auth/refresh', '/authentication/login', '/authentication/register'];
  const isPublicEndpoint = publicEndpoints.some(endpoint => req.url.includes(endpoint));

  if (!isPublicEndpoint && tenantId) {
    req = req.clone({
      setHeaders: {
        'X-Tenant-Id': tenantId
      }
    });
  }

  // Add Business Unit ID if available
  if (!isPublicEndpoint && businessUnitId) {
    req = req.clone({
      setHeaders: {
        'X-Business-Unit-Id': businessUnitId.toString()
      }
    });
  }

  return next(req);
};
